import '../GameEventToast/game-event-toast.scss';

import { AlertTriangle, CheckCircle2, Info, LucideIcon } from 'lucide-react';

export interface SystemToastProps {
  title: string;
  description?: string;
  type?: 'success' | 'error' | 'info';
  customIcon?: LucideIcon;
}

export function SystemToast({
  title,
  description,
  type = 'info',
  customIcon: Icon,
}: SystemToastProps) {
  // Map our logical types to the existing CSS modifiers
  const styleMod = type === 'success' ? 'win' : type === 'error' ? 'loss' : 'info';

  // Resolve Icon
  const ResolvedIcon = Icon
    ? Icon
    : type === 'success'
      ? CheckCircle2
      : type === 'error'
        ? AlertTriangle
        : Info;

  return (
    <div className={`get get--${styleMod}`}>
      <div className="get__icon">
        <ResolvedIcon size={18} />
      </div>
      <div className="get__body" style={{ justifyContent: 'center' }}>
        <span className={`get__main get__main--${styleMod}`}>{title}</span>
        {description && <span className="get__sub">{description}</span>}
      </div>
    </div>
  );
}
